if (!customElements.get("background-media")) {
  class ComponentBackgroundMedia extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this;
      this.isInViewPort = false;
      this.needButtonFocus = false;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.querySelectorAll(".media-wrap").forEach(
          (x) => (x.userPaused = true)
        );
      }

      setTimeout(() => {
        //The timeout is for the customizer
        this.initVideos();
      }, 1);
    }

    initVideos() {
      if (this.hasVideos()) {
        this.updateVideos();

        this.wrapper.querySelectorAll(".play").forEach((button) => {
          button.addEventListener("click", () => {
            this.needButtonFocus = true;
            button.closest(".media-wrap").userPaused = false;
            this.playVideo(
              button.closest(".media-wrap").querySelector(".video-element")
            );
          });
        });
        this.wrapper.querySelectorAll(".pause").forEach((button) => {
          button.addEventListener("click", () => {
            this.needButtonFocus = true;
            button.closest(".media-wrap").userPaused = true;
            this.pauseVideo(
              button.closest(".media-wrap").querySelector(".video-element")
            );
          });
        });
        window.addEventListener("mediaChange", () => {
          this.updateVideos();
        });

        const observer = new IntersectionObserver(
          (entries) => {
            this.isInViewPort = entries.pop().isIntersecting;
            this.updateVideos();
          },
          { threshold: 0 }
        );
        observer.observe(this.wrapper);
      }
    }

    updateVideos() {
      var currentSlide = this.wrapper;
      if (this.isInViewPort) {
        this.loadVideos(currentSlide);
        this.wrapper.querySelectorAll(".video-element").forEach((video) => {
          this.pauseVideo(video);
        });
        currentSlide.querySelectorAll(".video-element").forEach((video) => {
          if ($s.isVisible(video)) {
            this.playVideo(video);
          }
        });
      } else {
        currentSlide.querySelectorAll(".video-element").forEach((video) => {
          if ($s.isVisible(video)) {
            this.pauseVideo(video);
          }
        });
      }
    }

    hasVideos() {
      return this.wrapper.querySelectorAll(".video-element").length > 0;
    }

    loadVideos(slide) {
      slide.querySelectorAll("video").forEach((video) => {
        if ($s.isVisible(video) && !video.dataset.initialized) {
          var videoWrap = video.closest(".media-wrap");
          video.addEventListener("play", () => {
            videoWrap
              .querySelector(".play")
              .setAttribute("style", "display: none !important");
            videoWrap
              .querySelector(".pause")
              .setAttribute("style", "display: flex !important");
            if (this.needButtonFocus) {
              this.needButtonFocus = false;
              videoWrap.querySelector(".pause").focus();
            }
          });
          video.addEventListener("pause", () => {
            videoWrap
              .querySelector(".play")
              .setAttribute("style", "display: flex !important");
            videoWrap
              .querySelector(".pause")
              .setAttribute("style", "display: none !important");
            if (this.needButtonFocus) {
              this.needButtonFocus = false;
              videoWrap.querySelector(".play").focus();
            }
          });
          var source = video.querySelector("source");
          source.setAttribute("src", source.dataset.src);
          video.dataset.initialized = true;
          video.load();
        }
      });
      /*
      //for iframe
      slide.querySelectorAll('.js-youtube').forEach((video)=>{
        if($s.isVisible(video) && !video.dataset.initialized) {
          video.whenready = new Promise(resolve=>{
            if (video.loaded) {
              resolve();
            } else {
              video.addEventListener('load', resolve);
            }
          });
        }
      });*/

      //for youtube API
      slide.querySelectorAll(".js-youtube").forEach((video) => {
        if ($s.isVisible(video) && !video.dataset.initialized) {
          video.dataset.initialized = true;
          video.whenready = new Promise((resolve) => {
            window.YTReady.then(() => {
              video.player = new YT.Player(video, {
                height: video.dataset.height,
                width: video.dataset.width,
                videoId: video.dataset.videoId,
                events: {
                  onReady: function () {
                    resolve();
                  },
                  onStateChange: (evt) => {
                    if (video.player.intervalId) {
                      clearInterval(video.player.intervalId);
                    }
                    if (evt.data == YT.PlayerState.PLAYING || evt.data == -1) {
                      video.player.intervalId = setInterval(() => {
                        if (
                          video.player.getDuration() -
                            video.player.getCurrentTime() <
                          2
                        ) {
                          video.player.seekTo(0);
                        }
                      }, 250);
                    }
                  },
                },
                playerVars: {
                  fs: 0,
                  playlist: video.dataset.videoId,
                  loop: 1,
                  autoplay: 0,
                  mute: 1,
                  enablejsapi: 1,
                  origin: location.origin,
                  playsinline: 1,
                  rel: 0,
                  showinfo: 0,
                  iv_load_policy: 3,
                  autohide: 0,
                  cc_load_policy: 0,
                  modestbranding: 1,
                },
              });
            });
          });
        }
      });
    }

    playVideo(video) {
      if (video) {
        let videoWrap = video.closest(".media-wrap");
        if (videoWrap.userPaused) {
          return;
        }
        var doAction = () => {
          try {
            $s.playMedia(videoWrap.querySelector(".video-element"));
            if (video.tagName != "VIDEO") {
              videoWrap
                .querySelector(".play")
                .setAttribute("style", "display: none !important");
              videoWrap
                .querySelector(".pause")
                .setAttribute("style", "display: flex !important");
              if (this.needButtonFocus) {
                this.needButtonFocus = false;
                videoWrap.querySelector(".pause").focus();
              }
            }
          } catch (e) {
            console.warn(e);
          }
        };

        if (video.whenready) {
          video.whenready.then(() => {
            doAction();
          });
        } else {
          doAction();
        }
      }
    }

    pauseVideo(video) {
      if (video) {
        let videoWrap = video.closest(".media-wrap");
        var doAction = () => {
          try {
            $s.pauseMedia(videoWrap.querySelector(".video-element"));
            if (video.tagName != "VIDEO") {
              videoWrap
                .querySelector(".play")
                .setAttribute("style", "display: flex !important");
              videoWrap
                .querySelector(".pause")
                .setAttribute("style", "display: none !important");
              if (this.needButtonFocus) {
                this.needButtonFocus = false;
                videoWrap.querySelector(".play").focus();
              }
            }
          } catch (e) {
            console.warn(e);
          }
        };

        if (video.whenready) {
          video.whenready.then(() => {
            doAction();
          });
        } else {
          doAction();
        }
      }
    }
  }
  customElements.define("background-media", ComponentBackgroundMedia);
}
